import React, { useState, useEffect, useRef } from "react";
// import "../css/HeroBanner.css";

const API                      = "/api";
const CLOUDINARY_UPLOAD_PRESET = "ofak_assets"; 
const CLOUDINARY_CLOUD_NAME    = "dnriybfwk";    
 

const EMPTY_BANNER = { imageUrl: "", altText: "", heading: "", subheading: "" };

export default function HeroBanner() {
  const [banners, setBanners]   = useState([{ ...EMPTY_BANNER }]);
  const [pageSlug, setPageSlug] = useState("home");
  const [uploading, setUploading] = useState({});   // { [index]: pct }
  const [previews, setPreviews]   = useState({});   // { [index]: url }
  const [loading, setLoading]     = useState(false);
  const [fetching, setFetching]   = useState(true);
  const [dragOver, setDragOver]   = useState(null); // index | null
  const [notif, setNotif]         = useState(null);
  const fileRefs = useRef({});

  // ── load existing banners ─────────────────────────────
  useEffect(() => {
    fetch(`${API}/home/banners/${pageSlug}`)
      .then((r) => r.json())
      .then((data) => {
        const doc = data.data ?? data;
        const arr = Array.isArray(data.heroBanner) 
          ? data.heroBanner
          : [];
          // : doc?.heroBanner
          // ? [doc.heroBanner]
          // : null;
        if (arr && arr.length > 0) {
          setBanners(arr.map((b) => ({ imageUrl: b.imageUrl ?? "", altText: b.altText ?? "", heading: b.heading ?? "", subheading: b.subheading ?? "" })));
          const p = {};
          arr.forEach((b, i) => { if (b.imageUrl) p[i] = b.imageUrl; });
          setPreviews(p);
        } else {
          setBanners([{...EMPTY_BANNER}]);
          setPreviews({});
        }
      })
      .catch(() => {
        setBanners([{ ...EMPTY_BANNER }]);
      setPreviews({});
      })
      .finally(() => setFetching(false));
  }, [pageSlug]);

  const notify = (msg, type = "success") => {
    setNotif({ msg, type });
    setTimeout(() => setNotif(null), 3500);
  };

  // ── banner field change ───────────────────────────────
  const handleChange = (index, field, value) => {
    setBanners((prev) => prev.map((b, i) => i === index ? { ...b, [field]: value } : b));
  };

  // ── add / remove / move ───────────────────────────────
  const addBanner = () => {
    setBanners((prev) => [...prev, { ...EMPTY_BANNER }]);
  };

  const removeBanner = (index) => {
    if (banners.length === 1) { notify("At least one banner is required", "error"); return; }
    setBanners((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => {
      const next = {};
      Object.entries(prev).forEach(([k, v]) => {
        const ki = parseInt(k);
        if (ki < index) next[ki] = v;
        else if (ki > index) next[ki - 1] = v;
      });
      return next;
    });
  };

  const moveBanner = (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= banners.length) return;
    setBanners((prev) => {
      const next = [...prev];
      [next[index], next[target]] = [next[target], next[index]];
      return next;
    });
    setPreviews((prev) => {
      const next = { ...prev };
      [next[index], next[target]] = [next[target], next[index]];
      return next;
    });
  };

  // ── Cloudinary upload ─────────────────────────────────
  const uploadToCloudinary = (file, index) => {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`);
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable)
          setUploading((u) => ({ ...u, [index]: Math.round((e.loaded / e.total) * 100) }));
      };
      xhr.onload = () => {
        setUploading((u) => { const n = { ...u }; delete n[index]; return n; });
        const res = JSON.parse(xhr.responseText);
        xhr.status === 200 ? resolve(res.secure_url) : reject(new Error(res.error?.message ?? "Upload failed"));
      };
      xhr.onerror = () => { setUploading((u) => { const n = { ...u }; delete n[index]; return n; }); reject(new Error("Network error")); };
      xhr.send(data);
    });
  };

  const handleFile = async (file, index) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) { notify("Please select an image file", "error"); return; }
    if (file.size > 1 * 1024 * 1024)   { notify("Image must be under 1 MB", "error"); return; }

    const blob = URL.createObjectURL(file);
    setPreviews((p) => ({ ...p, [index]: blob }));
    setUploading((u) => ({ ...u, [index]: 0 }));

    try {
      const url = await uploadToCloudinary(file, index);
      handleChange(index, "imageUrl", url);
      setPreviews((p) => ({ ...p, [index]: url }));
      notify(`Banner ${index + 1} image uploaded ✓`);
    } catch (err) {
      notify(err.message, "error");
      setPreviews((p) => { const n = { ...p }; delete n[index]; return n; });
    }
  };

  const onFileInput  = (e, i)    => handleFile(e.target.files[0], i);
  const onDrop       = (e, i)    => { e.preventDefault(); setDragOver(null); handleFile(e.dataTransfer.files[0], i); };
  const onDragOver   = (e, i)    => { e.preventDefault(); setDragOver(i); };
  const onDragLeave  = ()        => setDragOver(null);
  const removeImage  = (index)   => { setPreviews((p) => { const n = { ...p }; delete n[index]; return n; }); handleChange(index, "imageUrl", ""); };

  // ── save ──────────────────────────────────────────────
  const handleSubmit = async (e) => {
    console.log("entered submit banners");
    e.preventDefault();
    for (let i = 0; i < banners.length; i++) {
      if (!banners[i].imageUrl)         { notify(`Banner ${i + 1}: upload an image first`, "error"); return; }
      if (!banners[i].heading.trim())   { notify(`Banner ${i + 1}: heading is required`, "error"); return; }
    }
    console.log("banners", banners);
    setLoading(true);
    try {
      await fetch('/api/home/banners', {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ pageSlug, heroBanner: banners }),
      });
      notify("All banners saved successfully!");
    } catch {
      notify("Failed to save — check your connection", "error");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return (
    <div className="hb-wrap">
      <div className="hb-loading"><span className="hb-spinner" /> Loading banner data…</div>
    </div>
  );

  const allUploading = Object.keys(uploading).length > 0;

  return (
    <>
      <div className="hb-wrap">

        {/* ── Page Header ── */}
        <div className="hb-slug-badge">
  Page:
  <select
    value={pageSlug}
    onChange={(e) => setPageSlug(e.target.value)}
    className="hb-page-select"
  >
    <option value="home">Home</option>
    <option value="about">About</option>
    <option value="vehicles">Vehicles</option>
    <option value="dealers">Dealers</option>
    <option value="careers">Careers</option>
    <option value="contact">Contact</option>
  </select>
</div>
        {/* <div className="hb-page-header">
          <div>
            <h1>Hero Banners</h1>
            <p>Manage all hero banners for the home page</p>
          </div>
          <div className="hb-slug-badge"> Page: <strong>home</strong></div>
        </div> */}

      

        <form className="hb-form" onSubmit={handleSubmit}>

          {banners.map((banner, index) => (
            <div className="hb-card" key={index}>

              {/* ── Card Header ── */}
              <div className="hb-card-header">
                <span className="hb-card-icon">🖼️</span>
                <div className="hb-card-header-text">
                  <div className="hb-card-title">Banner {index + 1}</div>
                  <div className="hb-card-desc">
                    {banner.heading ? `"${banner.heading}"` : "No heading yet"}
                  </div>
                </div>
                <div className="hb-card-actions">
                  <button type="button" className="hb-action-btn" title="Move up"
                    onClick={() => moveBanner(index, -1)} disabled={index === 0}>↑</button>
                  <button type="button" className="hb-action-btn" title="Move down"
                    onClick={() => moveBanner(index, 1)} disabled={index === banners.length - 1}>↓</button>
                  <button type="button" className="hb-action-btn danger" title="Remove banner"
                    onClick={() => removeBanner(index)}>✕</button>
                </div>
              </div>

              <div className="hb-card-body">

                {/* ── Image Upload ── */}
                <div className="hb-section-label">
                  <span className="hb-section-dot" />
                  Banner Image
                </div>

                {previews[index] ? (
                  <div className="hb-preview-wrap">
                    <img src={previews[index]} alt="preview" className="hb-preview-img" />
                    <div className="hb-preview-overlay">
                      <button type="button" className="hb-preview-btn change"
                        onClick={() => fileRefs.current[index]?.click()}>🔄 Change</button>
                      <button type="button" className="hb-preview-btn remove"
                        onClick={() => removeImage(index)}>🗑 Remove</button>
                    </div>
                    {uploading[index] !== undefined && (
                      <div className="hb-progress-bar-wrap">
                        <div className="hb-progress-bar" style={{ width: `${uploading[index]}%` }} />
                        <span className="hb-progress-label">{uploading[index]}%</span>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className={`hb-dropzone ${dragOver === index ? "drag-over" : ""} ${uploading[index] !== undefined ? "uploading" : ""}`}
                    onDrop={(e) => onDrop(e, index)}
                    onDragOver={(e) => onDragOver(e, index)}
                    onDragLeave={onDragLeave}
                    onClick={() => uploading[index] === undefined && fileRefs.current[index]?.click()}
                  >
                    {uploading[index] !== undefined ? (
                      <div className="hb-upload-progress">
                        <span className="hb-spinner large" />
                        <span className="hb-upload-pct">{uploading[index]}%</span>
                        <span className="hb-upload-label">Uploading to Cloudinary…</span>
                      </div>
                    ) : (
                      <>
                        <div className="hb-drop-icon">☁️</div>
                        <div className="hb-drop-title">Drag & drop or click to upload</div>
                        <div className="hb-drop-sub">PNG, JPG, WebP — max 1 MB</div>
                        <button type="button" className="hb-browse-btn">Browse Files</button>
                      </>
                    )}
                  </div>
                )}

                <input
                  type="file" accept="image/*" className="hb-file-input"
                  ref={(el) => (fileRefs.current[index] = el)}
                  onChange={(e) => onFileInput(e, index)}
                />

                {banner.imageUrl && (
                  <div className="hb-url-display">
                    <span className="hb-url-label">Cloudinary URL</span>
                    <span className="hb-url-value">{banner.imageUrl}</span>
                  </div>
                )}

                {/* ── Text Fields ── */}
                <div className="hb-section-label" style={{ marginTop: 4 }}>
                  <span className="hb-section-dot" />
                  Banner Content
                </div>

                <div className="hb-fields-grid">
                  <div className="field">
                    <label>Heading <span className="required">*</span></label>
                    <input type="text" placeholder="e.g. Welcome to Our Store"
                      value={banner.heading}
                      onChange={(e) => handleChange(index, "heading", e.target.value)} />
                    <span className="field-hint">{banner.heading.length} characters</span>
                  </div>

                  <div className="field">
                    <label>Alt Text <span className="field-tag">SEO & Accessibility</span></label>
                    <input type="text" placeholder="e.g. Home page hero banner image"
                      value={banner.altText}
                      onChange={(e) => handleChange(index, "altText", e.target.value)} />
                  </div>
                </div>

                <div className="field">
                  <label>Subheading</label>
                  <textarea placeholder="e.g. Discover our latest collection of premium products"
                    value={banner.subheading}
                    onChange={(e) => handleChange(index, "subheading", e.target.value)} />
                  <span className="field-hint">{banner.subheading.length} characters</span>
                </div>

                {/* ── Mini Live Preview ── */}
                {(previews[index] || banner.heading) && (
                  <div className="hb-mini-preview" style={previews[index] ? { backgroundImage: `url(${previews[index]})` } : {}}>
                    <div className="hb-mini-overlay">
                      {banner.heading    && <div className="hb-mini-heading">{banner.heading}</div>}
                      {banner.subheading && <div className="hb-mini-sub">{banner.subheading}</div>}
                    </div>
                    {!previews[index] && <div className="hb-no-img">No image yet</div>}
                  </div>
                )}

              </div>
            </div>
          ))}

          {/* ── Add Banner ── */}
          <button type="button" className="hb-add-btn" onClick={addBanner}>
            <span className="hb-add-icon">+</span>
            Add Another Banner
          </button>

          {/* ── Submit ── */}
          <div className="submit-row">
            <span className="save-hint">
              {banners.length} banner{banners.length > 1 ? "s" : ""} — {banners.filter((b) => b.imageUrl && b.heading).length} ready
            </span>
            <button type="submit" className="save-btn" disabled={loading || allUploading}>
              {loading ? "Saving…" : allUploading ? "Uploading…" : `Save ${banners.length} Banner${banners.length > 1 ? "s" : ""}`}
            </button>
          </div>

        </form>
      </div>

      {notif && (
        <div className={`notif ${notif.type === "error" ? "error" : ""}`}>
          <span className="notif-icon">{notif.type === "error" ? "✕" : "✓"}</span>
          {notif.msg}
        </div>
      )}
    </>
  );
}